// extraChargeConfig.js

import {
    FaBolt,
    FaRegFileAlt,
    FaTools,
    FaUtensils,
    FaHandshake,
    FaRunning,
    FaBroom,
    FaWifi,
    FaBus,
} from "react-icons/fa";
import { GrVmMaintenance } from "react-icons/gr";
import { GiExpense, GiWashingMachine } from "react-icons/gi";
import tw from "tailwind-styled-components";
import Config from "../Config";

export const extraChargeConfig = {
    [Config.dueType.MAINTENANCE]: {
        label: "Maintenance",
        icon: GrVmMaintenance,
        color: "text-teal-500",
    },
    [Config.dueType.ELECTRICITY]: {
        label: "Electricity",
        icon: FaBolt,
        color: "text-blue-500",
    },
    [Config.dueType.REGISTRATION]: {
        label: "Registration",
        icon: FaRegFileAlt,
        color: "text-green-500",
    },
    [Config.dueType.TECH_CHARGES]: {
        label: "Tech Charges",
        icon: FaTools,
        color: "text-yellow-500",
    },
    [Config.dueType.AGREEMENT_CHARGE]: {
        label: "Agreement Charges",
        icon: FaHandshake,
        color: "text-purple-500",
    },
    [Config.dueType.FOOD]: {
        label: "Food",
        icon: FaUtensils,
        color: "text-red-500",
    },
    [Config.dueType.WIFI]: {
        label: "Wi-Fi Charges",
        icon: FaWifi,
        color: "text-cyan-500",
    },
    [Config.dueType.MAID_CHARGES]: {
        label: "Maid/Cleaning Charges",
        icon: FaBroom,
        color: "text-teal-500",
    },
    [Config.dueType.LAUNDRY_CHARGES]: {
        label: "Laundry Charges",
        icon: GiWashingMachine,
        color: "text-blue-500",
    },
    [Config.dueType.BUS_CHARGES]: {
        label: "Bus Charges",
        icon: FaBus,
        color: "text-sky-500",
    },
    [Config.dueType.MOVE_OUT_CHARGES]: {
        label: "Move Out Charges",
        icon: FaRunning,
        color: "text-rose-500",
    },
    [Config.dueType.OTHER]: {
        label: "Other",
        icon: GiExpense,
        color: "text-orange-500",
    },
};

export const renderExtraChargeType = (type) => {
    const item =
        extraChargeConfig[type] ||
        extraChargeConfig[Config.dueType.OTHER];

    const Icon = item.icon;

    return (
        <TypeWrapper>
            <Icon className={`${item.color} mr-2 w-5 h-5`} />
            <TypeLabel>{item.label}</TypeLabel>
        </TypeWrapper>
    );
};

export const extraChargeOptions = Object.entries(extraChargeConfig).map(
    ([value, item]) => ({
        value: Number(value),
        label: item.label,
    })
);

const TypeWrapper = tw.div`
  flex items-center gap-3
`;

const TypeLabel = tw.p`
  text-sm font-medium text-gray-800
`;